import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import Form from "./Form";
import Navbar from "../navbar";

const LoginPage = () => {
  const theme = useTheme();
  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
  return (
    <Box>
      <Navbar />

      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        // p="1rem"
      >
        <Box
          width={isNonMobileScreens ? "40%" : "90%"}
          p="2rem"
          m="1rem auto"
          borderRadius="1.5rem"
          backgroundColor={theme.palette.background.alt}
          sx={{
            boxShadow: 3,
          }}
        >
          <Typography
            fontWeight="bold"
            variant="h4"
            sx={{ mb: "1rem", textAlign: "center", color: theme.palette.primary.main }}
          >
            Welcome to Sociopedia
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: "1.5rem", textAlign: "center" }}>
            The Social Media for Sociopaths!
          </Typography>
          <Form />
        </Box>
      </Box>
    </Box>
  );
};

export default LoginPage;